<div>
  <table mat-table
         [dataSource]="dropDays"
         [trackBy]="trackByFn">
    <ng-container matColumnDef="dayNumber">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let index = index;">
        {{ 'Day' | translate }} {{ index + 1 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="promo">
      <th mat-header-cell *matHeaderCellDef>{{ 'Promo' | translate }}</th>
    </ng-container>

    <ng-container matColumnDef="dayDrops">
      <th mat-header-cell *matHeaderCellDef>{{ 'Total Drops' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.drops.length }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalDrops">
      <th mat-header-cell *matHeaderCellDef>{{ getTotalDropsCount() | number }}</th>
    </ng-container>

    <ng-container matColumnDef="dayPrizes">
      <th mat-header-cell
          *matHeaderCellDef>{{ 'Total Prizes' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.dropPrizeSums.qtySum | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalPrizes">
      <th mat-header-cell *matHeaderCellDef>{{ getTotalPrizes() | number }}</th>
    </ng-container>

    <ng-container matColumnDef="dayAmount">
      <th mat-header-cell
          *matHeaderCellDef>{{ 'Total Amount' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.dropPrizeSums.totalMinPrizeSum | number: '1.2-2' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef>{{ getTotalAmount() | number: '1.2-2' }}</th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"
        class="first-header-row">
    </tr>
    <tr mat-header-row *matHeaderRowDef="multipleHeaderColumns"
        class="second-header-row">
    </tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>